import React from 'react';
import autoBind from 'react-autobind';
//
import { Avatar, Dropdown, Tag, Typography } from 'antd';
import { UserOutlined, ExportOutlined } from '@ant-design/icons';
//
export default class IDMUserBadge extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }
  render() {
    return (
      <Dropdown menu={{ items: this._getMenuItems() }}>
        <Tag className="idmBadgeContainer">
          <Avatar justify="end" size={this.props.squeeze ? 30 : 40} className="idmBadgeUserIcon">
            <Typography.Text className="idmBadgeUserText">{this.props.user?.firstName?.substr(0, 1)}</Typography.Text>
          </Avatar>
        </Tag>
      </Dropdown>
    );
  }
  _getMenuItems() {
    return [
      {
        key: 'user-name',
        label: this.props.user?.firstName + ' ' + this.props.user?.lastName,
        icon: <UserOutlined />,
        disabled: true,
      },
      { type: 'divider' },
      {
        key: 'profile',
        label: 'Profile',
        onClick: this.props.openProfile,
      },
      {
        key: 'change-password',
        label: 'Change password',
        onClick: this.props.changePassword,
      },
      {
        key: 'logout',
        label: <><ExportOutlined /> Logout</>,
        onClick: this.props.logoutHandler,
      },
    ];
  }
}
